import { isDesktop } from 'react-device-detect';
import TextMetricController from '../../controllers/TextMetricController';
import BonusGameDialogueController from '../../controllers/bonus/BonusGameDialogueController';
import MainGridController from '../../controllers/grid/MainGridController';
import { COMPONENTS } from '../../lib/constants';
import { BonusItems } from '../splash-screen/elements/BonusItems';
import { BonusGameDialogueGridView } from './BonusGameDialogueGridView';

export const BonusGameDialogueView = {
	name: COMPONENTS.BONUS_GAME_DIALOGUE,
	child: true,
	zIndex: 2,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: BonusGameDialogueController,
			name: 'BonusGameDialogueController',
			config: {
				item: 'bonus_game_dialogue_wrapper',
				val: 'bonus_game_dialogue_wrapper'
			}
		},
		{
			Controller: TextMetricController,
			name: 'TextMetricController',
			config: {
				item: 'bonus_game_dialogue_wrapper',
				val: 'bonus_game_dialogue_wrapper',
				position: { x: 0, y: 0, w: 1137 },
				texts: [
					{
						value: 'BONUS_ROUND_DIALOGUE_TEXT_4',
						position: { x: 0, y: 380 }
						// maxLineWidth: 1.5,
						// wordWrap: true
					}
				]
			}
		},
		{
			Controller: MainGridController,
			name: 'bonusgamegridController',
			config: BonusGameDialogueGridView
		}
	],
	components: [
		{
			name: 'bonus_game_dialogue_wrapper',
			type: 'Sprite',
			components: [
				{
					name: 'bg',
					type: 'Sprite',
					img: 'reel_bg',
					scale: {
						x: isDesktop ? 1 : 2,
						y: isDesktop ? 1 : 2
					},
					position: { x: 0, y: 0 }
				},
				{
					name: 'bg_border',
					type: 'Sprite',
					img: 'reel_border',
					position: { x: 0, y: -5 },
					scale: {
						x: isDesktop ? 1 : 2,
						y: isDesktop ? 1 : 2
					}
				},
				{
					name: 'text',
					type: 'Text',
					text: 'BONUS_ROUND_DIALOGUE_HEADER',
					position: { x: 1144 / 2, y: 70 },
					anchor: { x: 0.5, y: 0.5 }
				},
				{
					name: 'text_1',
					type: 'Text',
					text: 'BONUS_ROUND_DIALOGUE_TEXT_1',
					position: { x: 1144 / 2, y: 140 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'BONUS_ROUND_DIALOGUE_TEXT_2',
					type: 'Text',
					text: 'BONUS_ROUND_DIALOGUE_TEXT_2',
					position: { x: 1144 / 2, y: 240 },
					anchor: { x: 0.5, y: 0.5 }
				},
				{
					name: 'text_3',
					type: 'Text',
					text: 'BONUS_ROUND_DIALOGUE_TEXT_3',
					position: { x: 1144 / 2, y: 330 },
					anchor: { x: 0.5, y: 0.5 }
				},
				{
					name: 'BONUS_ROUND_DIALOGUE_TEXT_4',
					type: 'Text',
					text: 'BONUS_ROUND_DIALOGUE_TEXT_4',
					position: { x: 1144 / 2, y: 380 },
					anchor: { x: 0.5, y: 0.5 }
				},
				{
					name: 'progressive_bonus',
					position: { x: 40, y: 650 },
					type: 'VisualComponent',
					component: BonusItems
				}
			]
		}
	]
};
